
import { defineComponent } from '@vue/composition-api';
import { FCButton } from '@fc/angie-ui';
import ReviewsGrid from '~/components/storyblok/ReviewsGrid/ReviewsGrid.vue';
import FaqsCollapsibleContainer from '~/components/storyblok/FaqsCollapsibleContainer/FaqsCollapsibleContainer.vue';
import AtfWhatsIncluded from '~/components/v2/pdps/AtfWhatsIncluded.vue';
import specs from '~/data/shopSpecs';
import { CMSService } from '~/services/storyBlok/cmsService';

export default defineComponent({
  name: 'ShopFooterSections',
  components: {
    ReviewsGrid,
    FaqsCollapsibleContainer,
    AtfWhatsIncluded,
    FCButton,
  },
  props: {
    reviewsRating: {
      type: String,
      default: '4.9',
    },
    reviewsGalleryTitle: {
      type: String,
      default: 'Customer Photos',
    },
    reviewsRatingTitle: {
      type: String,
      default: '21,000+ Apple Store Reviews',
    },
    showBackToTop: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      specs,
      expandedSpecIndex: null,
      reviews: [],
      faqs: [],
    };
  },
  methods: {
    scrollToTop() {
      if (process.client) {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      this.$emit('backToTop');
    },
    toggleSpec(idx) {
      this.expandedSpecIndex = this.expandedSpecIndex === idx ? null : idx;
    },
  },
  async fetch() {
    try {
      const storyBlok = new CMSService({ cmsService: this.$storyapi });
      const reviews = await storyBlok.getAll('user-reviews', { sort_by: 'content.reviewDate:desc' });

      const faqs = await storyBlok.get('global/globalpackagefaqs');
      const faqList = faqs?.data?.story?.content?.global?.[0]?.container || [];

      this.reviews = reviews;
      this.faqs = faqList;
    } catch (e) {
      console.log(e);
    }
    return [];
  },
});
